const color = {
  text: {
    gray: "#777777",
    normal: "#656565",
    dark: "#232323",
    muted: "#999999",
    placeholder: "#bcbcbc",
  },

  icon: {
    // normal: '#a9a9a9',
    normal: "#cfc9c4",
  },

  modal_bg: { dark_glass: "#000000aa" },

  border: {
    normal: "#dfd9d4",
    light: "#efe9e4",
    lightest: "#f1ece7",
    // normal: '#f2f2f4',
  },

  // dark_theme: "#b13130",
  // theme: '#f14140',
  dark_theme: "#01579B",
  theme: "#0277BD",
  // theme: '#3f37c9',

  // bg: {element: '#ffffff', screen: '#f6f6f4', light: '#f7f7f8'},
  bg: {
    element: "#ffffff",
    screen: "#fff",
    light: "#f7f7f8",
    lightest: "#f9f9fa",
    minusBtn: "#dedfde",
  },

  splash: "#f6f6f4",

  white: "#ffffff",
  black: "#000000",

  success: "#28a745",
  info: "#0792a8",
  danger: "#dc3545",
  warning: "#f5a900",

  transparent: "transparent",
};

export default color;
